module.exports = __webpack_public_path__ + "static/img/SunPeak_On_Dark.f657462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SunPeak_On_Dark.png
// module id = gldD
// module chunks = 1